(async () => {
  var e = await import(window.theme.modules.baseComponent);
  customElements.define(
    "slideshow-thumbnails",
    class extends e.default {
      elements = { items: "*[data-item]" };
      onSliderLoad(e) {
        (this.slider = e),
          this._setActive(this.slider.swiper.activeIndex),
          this.$items.map((e, t) => {
            e.addEventListener("click", () => {
              this.slider.slideTo(t);
            });
          }),
          this.slider.swiper.on("slideChange", () => {
            this._setActive(this.slider.swiper.activeIndex);
          });
      }
      _setActive(e) {
        this.active && this.active.classList.remove("!active"),
          (this.active = this.$items[e]),
          this.active.classList.add("!active"),
          this.hasAttribute("horizontal")
            ? (this.active.parentNode.scrollLeft = this.active.offsetLeft - 200)
            : (this.active.parentNode.scrollTop = this.active.offsetTop - 200);
      }
    }
  );
})();
